import React from 'react';
import { makeStyles } from '@mui/styles';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        width: 'auto',
        height: 'auto',
        transform: 'translateZ(0)',
    },
    fullHeight: {
        height: '100%'
    }
}));

export default function PropertyImagesGridList(props) {
    const classes = useStyles();
    const { propertyDetails = [] } = props;
    const { photos } = propertyDetails ? propertyDetails : {};
    let tileData =
        photos && Array.isArray(photos) ? photos : [];


    return (
        <div className={classes.root}>
            <ImageList cellHeight={200} className={classes.gridList} cols={3}>
                {tileData.map((img, index) => (
                    <ImageListItem key={index} cols={(index%4) > 0 ? 1 : 3} rows={(index%4) > 0 ? 1 : 2}>
                        <img src={img} alt={"Property Image"} className={classes.fullHeight}  />
                    </ImageListItem>
                ))}
            </ImageList>
        </div>
    );
}

